'use strict';

angular.module('cvsApp').controller('SrxPaymentWidgetCtrl', ["$scope", "$stateParams",function ($scope, $stateParams) {
    $scope.display = $stateParams.display || 'content';
    $scope.content = wcmContent;
    

    /*UTAG VIEW*/
    /*if (typeof utag != 'undefined') {
     if (aBal.showErrBal || !aBal.showView) {
     utag.view({form_field_error: 'SOP:' + (aBal.acBalError == "" ? data.getResponse().apiResponse.apiMsg.statusDesc : aBal.acBalError)});
     } else {
     utag.view({
     page_name: 'My Account: Dashboard',
     page_category: 'My Account',
     scenario_name: 'OnlinePayment',
     scenario_step: '1-Entry'
     });
     }
     }*/
}]);
